module.exports = require("core-js/library/fn/object/set-prototype-of");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/object/set-prototype-of.js
// module id = 151
// module chunks = 35783957827783 70144966829960 114276838955818 198517197184460